/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class RedshiftServerlessNamespace {
  /**
  * The name of the Redshift Serverless namespace
  */
  'namespaceName': string;
  /**
  * The unique ID of the namespace
  */
  'namespaceId': string;
  /**
  * The status of the namespace (e.g. AVAILABLE, MODIFYING)
  */
  'status': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "namespaceName",
      "baseName": "namespaceName",
      "type": "string",
      "format": ""
    },
    {
      "name": "namespaceId",
      "baseName": "namespaceId",
      "type": "string",
      "format": ""
    },
    {
      "name": "status",
      "baseName": "status",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RedshiftServerlessNamespace.attributeTypeMap;
  }

  public constructor() {
  }
}

